export default __webpack_public_path__ + "static/media/vastaanotto-white.14c96a25.svg";